import PropTypes from 'prop-types';
import { isNil } from 'ramda';
import { isNilOrEmpty } from 'ramda-extension';

import { getLabelMessage } from '@gef-ui/localization/messages';
import { joinString } from '@gef-ui/utils';

import SidebarSection from 'components/atoms/GefMui/SidebarSection';
import { PKUrl, SidebarInfo, SidebarInfoColumn } from 'components/index';
import { equalOrThreeDashes } from 'utils/equalOrThreeDashes';
import { mailToLink, phoneToLink } from 'utils/links';

export const Client = ({ contact = {} }) => {
	const { client = {}, campaign = {} } = contact;
	const { address = {}, ccdId } = client;
	const streetNo = isNil(address.streetNo) ? '' : ` ${address.streetNo}`;
	const street = isNilOrEmpty(address.street) ? equalOrThreeDashes(address.street) : `${address.street}${streetNo}`;

	const { communicationCode, endDate } = campaign;

	return (
		<SidebarSection heading={getLabelMessage('contactDetail:client')}>
			<SidebarInfo>
				{(!isNilOrEmpty(client.title) || !isNilOrEmpty(client.titleSuffix)) && (
					<SidebarInfoColumn
						attribute={getLabelMessage('contactDetail:degree')}
						value={joinString(', ', [client.title, client.titleSuffix])}
					/>
				)}
				{!isNilOrEmpty(client.surname) && (
					<SidebarInfoColumn
						attribute={getLabelMessage('contactDetail:surname')}
						value={
							<PKUrl.PKPartner
								partnerId={client.surname ? ccdId : null}
								unlock
								campaignEndDate={endDate}
								communicationCode={communicationCode}
								muiLink
							>
								{client.surname}
							</PKUrl.PKPartner>
						}
					/>
				)}
				{!isNilOrEmpty(client.firstname) && (
					<SidebarInfoColumn attribute={getLabelMessage('contactDetail:name')} value={client.firstname} />
				)}
				{!isNilOrEmpty(client.personIn) && (
					<SidebarInfoColumn
						attribute={getLabelMessage('contactDetail:dateNumber')}
						value={client.personIn}
					/>
				)}
				{!isNilOrEmpty(client.businessIn) && (
					<SidebarInfoColumn
						attribute={getLabelMessage('contactDetail:businessIn')}
						value={client.businessIn}
					/>
				)}
				{!isNilOrEmpty(client.businessName) && (
					<SidebarInfoColumn
						attribute={getLabelMessage('contactDetail:businessName')}
						value={
							<PKUrl.PKPartner
								partnerId={client.businessName ? ccdId : null}
								unlock
								campaignEndDate={endDate}
								communicationCode={communicationCode}
								muiLink
							>
								{client.businessName}
							</PKUrl.PKPartner>
						}
					/>
				)}
				{!isNilOrEmpty(address.street) && (
					<SidebarInfoColumn attribute={getLabelMessage('contactDetail:street')} value={street} />
				)}
				{!isNilOrEmpty(address.city) && (
					<SidebarInfoColumn attribute={getLabelMessage('contactDetail:town')} value={address.city} />
				)}
				{!isNilOrEmpty(address.zipCode) && (
					<SidebarInfoColumn attribute={getLabelMessage('contactDetail:zipCode')} value={address.zipCode} />
				)}
				{!isNilOrEmpty(client.mobile) && (
					<SidebarInfoColumn
						attribute={getLabelMessage('contactDetail:phoneNumber')}
						value={phoneToLink(client.mobile, true)}
					/>
				)}
				{!isNilOrEmpty(client.phone) && (
					<SidebarInfoColumn
						attribute={getLabelMessage('contactDetail:phoneNumberTwo')}
						value={phoneToLink(client.phone, true)}
					/>
				)}
				{!isNilOrEmpty(client.email) && (
					<SidebarInfoColumn
						attribute={getLabelMessage('contactDetail:email')}
						value={mailToLink(client.email, true)}
					/>
				)}
			</SidebarInfo>
		</SidebarSection>
	);
};

Client.propTypes = {
	contact: PropTypes.object,
};

export default Client;
